import React from 'react'
import {Stack} from "@mui/material"
import {RoleCheck} from "../../../library/RoleCheck"
import {useApi} from "../../../hooks/useApi"
import {SystemRole} from "../../../api/enum/SystemRole"
import NavSidebarLink from "./NavSidebarLink"
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined"
import ExtensionOutlinedIcon from "@mui/icons-material/ExtensionOutlined"
import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined"
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined"
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined"
import SidebarShell from "../SidebarShell"
import {NAV_LABELS} from "../../../library/NavLabels"

function OrgSidebar() {
    const {currentUser} = useApi()
    const isAdmin = RoleCheck.isAdmin()

    return (
        <SidebarShell>
            {(collapsed) => (
                <>
                    <Stack spacing={2} alignItems={collapsed ? "center" : "stretch"}>
                        <NavSidebarLink to="" baseUrl="/" icon={FolderOutlinedIcon} collapsed={collapsed}>
                            {NAV_LABELS.PROJECTS}
                        </NavSidebarLink>

                        {isAdmin &&
                            <NavSidebarLink to="integrations" baseUrl="/" icon={ExtensionOutlinedIcon} collapsed={collapsed}>
                                {NAV_LABELS.INTEGRATIONS}
                            </NavSidebarLink>
                        }

                        {isAdmin &&
                            <NavSidebarLink to="organization/members" baseUrl="/" icon={PeopleOutlinedIcon} collapsed={collapsed}>
                                {NAV_LABELS.MEMBERS}
                            </NavSidebarLink>
                        }
                    </Stack>

                    <Stack spacing={2} alignItems={collapsed ? "center" : "stretch"}>
                        {isAdmin &&
                            <NavSidebarLink to="organization" baseUrl="/" icon={SettingsOutlinedIcon} collapsed={collapsed}>
                                {NAV_LABELS.SETTINGS}
                            </NavSidebarLink>
                        }

                        {currentUser?.systemRole === SystemRole.ADMIN &&
                            <NavSidebarLink to="admin" baseUrl="/" icon={AdminPanelSettingsOutlinedIcon} collapsed={collapsed}>
                                {NAV_LABELS.ADMIN}
                            </NavSidebarLink>
                        }
                    </Stack>
                </>
            )}
        </SidebarShell>
    )
}

export default OrgSidebar
